module.exports = __webpack_public_path__ + "static/media/09_andinvainthedreamer.16d3556a.jpg";